import axios from "axios";
import TokenService from "./token.service";

const baseURL = process.env.REACT_APP_API_URL;

const bilAPI = axios.create({
  baseURL,
  headers: {
    "Content-Type": "multipart/form-data",
    accept: "application/json",
    "Accept-Language": localStorage.getItem("i18nextLng"),
  },
});

bilAPI.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();

    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    } else {
      config.headers["Authorization"] = null;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

bilAPI.interceptors.response.use(
  (response) => response,
  async function (error) {
    const originalConfig = error?.response?.config;

    if (error.toJSON().message === "Network Error") {
      // alert('No internet connection');
      return Promise.reject(error);
    }

    if (originalConfig.url !== "/auth/login" && error?.response) {
      if (error?.response?.status === 401) {
        try {
          const rs = await axios.post(baseURL + "/auth/refresh/", {
            refresh: TokenService.getLocalRefreshToken(),
          });
          const token = rs.data.access;
          TokenService.updateLocalAccessToken(token);
          return bilAPI(originalConfig);
        } catch (error) {
          // if (window.location.pathname !== '/login') {
          //   window.location.href = '/login';
          // }
          TokenService.removeTokens();
          return Promise.reject(error);
        }
      } else {
        return Promise.reject(error);
      }
    }
  }
);

export default bilAPI;
